'use client';

import React, { useState } from 'react';

import { CasesDivider, CasesSection, CasesText } from '../../components';

import SvgArrowDown from '@/assets/icons/arrowDown.svg';
import { Button } from '@/shared/components/button';
import { SmallCard } from '@/shared/components/smallCard';

export const WhatDid = ({
  content,
  sectionTitle,
  introText,
  showMoreText,
}: {
  content: {
    imageSrc: string;
    description: string;
    subDescription: string;
    href: string;
    alt: string;
  }[];
  sectionTitle: string;
  introText: string;
  showMoreText: string;
}) => {
  const [showAll, setShowAll] = useState(false);

  const visibleCards = showAll ? content : content.slice(0, 4);

  return (
    <CasesSection>
      <CasesText size="big">{sectionTitle}</CasesText>
      <CasesDivider />
      <CasesText size="small">{introText}</CasesText>

      <div className="text- mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8">
        {visibleCards.map(
          ({ imageSrc, description, subDescription, href, alt }, idx) => (
            <SmallCard
              key={idx}
              imageSrc={imageSrc}
              description={description}
              subDescription={subDescription}
              href={href}
              alt={alt}
              isAnimateLinkIcon
              customClassNames={{
                content: '!text-2xl sm:!text-3xl',
                main: 'min-h-[400px] w-full',
              }}
            />
          ),
        )}
      </div>

      {!showAll && (
        <Button
          variant="primary"
          className="mx-auto mt-7 flex w-full items-center justify-center gap-1 sm:w-auto"
          onClick={() => setShowAll(true)}
        >
          <SvgArrowDown />
          {showMoreText}
        </Button>
      )}
    </CasesSection>
  );
};
